import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'planningactions-tooltip',
  templateUrl: './planningactions-tooltip.component.html',
  styleUrls: ['./planningactions-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningactionsTooltipComponent {}
